import apiClient from "./axios"

export const getAccountCustomerRefunds = async (params = {}) => {
  const { data } = await apiClient.get("/account-customer-refunds", { params })
  return data
}

export const getAccountCustomerRefund = async id => {
  const { data } = await apiClient.get(`/account-customer-refunds/${id}`)
  return data
}

export const createAccountCustomerRefund = async payload => {
  const { data } = await apiClient.post("/account-customer-refunds", payload)
  return data
}

export const updateAccountCustomerRefund = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-customer-refunds/${id}`, payload)
  return data
}

export const deleteAccountCustomerRefund = async id => {
  const { data } = await apiClient.delete(`/account-customer-refunds/${id}`)
  return data
}
